import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  empresa = environment.empresa

  constructor() { }

  ngOnInit(): void {
  }

  async showModal(modal_id: string){
    const modal = document.getElementById(modal_id);
    modal.style.display = "block";
  }

  hideModal(modal_id: string){
    var modal = document.getElementById(modal_id);
    modal.style.display = "none";
  }

}
